<template>
  <div style="min-height: 600px">
    <div v-if="this.$store.state.langchange">{{ updatedata() }}</div>
    <section id="Hero" v-if="!loading">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-12 order-lg-1">
            <div class="verticallingallery">
              <lingallery
                :addons="{ enableLargeView: true }"
                :iid.sync="currentId"
                :width="width"
                :height="height"
                :items="DBitems.images.images"
              />
            </div>
          </div>
          <div class="col-lg-5 col-12 order-lg-2">
            <div class="d-flex flex-row justify-content-between pb-0">
              <div class="section-title pb-0" @click="productRoute">
                <h2>{{ DBitems.product.name }}</h2>
              </div>
              <div class="d-flex flex-row justify-content-between pb-0">
                <router-link
                  :to="{
                    name: 'login',
                    params: { storeName: this.$store.storeName },
                  }"
                  v-if="loginMassage != ''"
                  style="
                    margin: 10px;
                    color: var(--primary-color);
                    text-decoration: 1px underline !important;
                    text-underline-offset: 5px;
                  "
                >{{ loginMassage }}</router-link>

                <!--v-if="this.$localStorage.get(this.$store.storeName) != null"-->
                <div class="myBtn">  ( 👁 {{ DBitems.count_sold }} ) </div>
                <img
                  class="fav-img"
                  :style="fav ? 'display: none' : 'display: block'"
                  src="../../../public/store/assets/image/icons/fav.svg"
                  @click="changeFav"
                />
                <img
                  class="fav-full-img"
                  :style="fav ? 'display: block' : 'display: none'"
                  src="../../../public/store/assets/image/icons/fav-fill.svg"
                  @click="changeFav"
                />
                <!-- <vodal
                      :show="loginVodal"
                      animation="flip"
                      @hide="loginVodal = false"
                      :width="600"
                      :height="450"
                      style="margin-top: 20px"
                    >
                      <login></login>
                </vodal>-->
              </div>
            </div>
            <!--<hr class="mobile-inactive" />-->
            <div class="row mt-2">
              <div class="col-sm-12">
                <div class="star d-flex flex-row justify-content-end w-100 mt-0">
                  <div class="d-flex flex-row justify-content-center">
                    <span v-for="n in DBitems.rate" :key="n">
                      <i class="star-fill bi bi-star-fill"></i>
                    </span>
                    <div class="d-flex flex-row justify-content-center">
                      <span v-for="n in 5 - DBitems.rate" :key="n">
                        <i class="star bi bi-star-fill"></i>
                      </span>
                      <span style="margin-top: 15px">({{ DBitems.count_rate }})</span>
                    </div>
                  </div>

                  <!--<b-form-rating
                    v-model="DBitems.rate"
                    readonly
                    show-value
                    show-value-max
                    precision="2"
                  ></b-form-rating>-->
                  <div>
                    <button
                      style="
                        background-color: #efefef;
                        border-radius: 5px;
                        text-align: center;
                        width: 30px;
                        height: 30px;
                        border: 0;
                        margin: 0 5px 0 5px;
                      "
                      @click="addEvalu"
                    >
                      <h5 href class="hovertext" data-hover="إضافة تقييم">+</h5>
                    </button>
                    <vodal
                      :show="addeval"
                      animation="flip"
                      @hide="addeval = false"
                      :width="600"
                      :height="450"
                      style="margin-top: 20px"
                    >
                      <add-evaluation></add-evaluation>
                    </vodal>
                  </div>
                </div>
              </div>
              
            </div>
            <!--<hr />-->
            <div class>
              <div
                class="orderInfo d-flex flex-row justify-content-between mt-4"
                v-if="this.DBitems.product.is_offer == true"
              >
                <span>{{ $t("offerProduct") }} :</span>
                <h5 style="color: var(--primary-color)">{{ this.DBitems.product.discount }} %</h5>
              </div>
              <div
                class="orderInfo d-flex flex-row justify-content-between mt-1"
                v-if="this.DBitems.product.is_offer == true"
              >
                <span>{{ $t("offerEnd") }} :</span>
                <h5 style="color: var(--primary-color)">{{ this.DBitems.product.offer_end }}</h5>
              </div>
              <div
                class="orderInfo d-flex flex-row justify-content-between mt-1"
                v-if="this.DBitems.tax != 0"
              >
                <span>{{ $t("thereistax") }} :</span>
                <h5 style="color: var(--primary-color)">{{ this.DBitems.tax }} %</h5>
              </div>
              <hr class="mobile-inactive" />
              <!--------------------------------------------------------------------->
              <div
                class="orderInfo d-flex flex-row justify-content-between mt-4"
                style="margin-bottom: 15px"
              >
                <h5>{{ $t("price") }} :</h5>
                <div v-if="selectOption">{{ $t("selectOption") }}</div>
                <div v-else class="d-flex flex-row justify-content-between">
                  <h5
                    v-if="$i18n.locale == 'ar'"
                    :style="
                    this.DBitems.product.is_offer
                      ? '  text-decoration: line-through ; font-size: 12px ;'
                      : 'color: var(--primary-color)'
                  "
                  >{{ price.toFixed(2) }} {{ $store.state.unitAR }}</h5>
                  <h5
                    v-if="$i18n.locale == 'en'"
                    :style="
                    this.DBitems.product.is_offer
                      ? '  text-decoration: line-through ; font-size: 12px'
                      : 'color: var(--primary-color)'
                  "
                  >{{ price.toFixed(2) }} {{ $store.state.unit }}</h5>
                  <h5
                    v-if="
                    this.DBitems.product.is_offer == true &&
                    $i18n.locale == 'ar'
                  "
                    style="color: var(--primary-color)"
                  >{{ offer_price.toFixed(2) }} {{ $store.state.unitAR }}</h5>
                  <h5
                    v-if="
                    this.DBitems.product.is_offer == true &&
                    $i18n.locale == 'en'
                  "
                  >{{ offer_price.toFixed(2) }} {{ $store.state.unit }}</h5>
                </div>
              </div>
              <div
                class="orderInfo d-flex flex-row justify-content-between"
                style="margin-bottom: 15px"
              >
                <h5>{{ $t("quantity") }} :</h5>

                <div v-if="quanity == 0 && !selectOption">{{ $t("NoQuantity") }}</div>
                <div v-else-if="selectOption">{{ $t("selectOption") }}</div>
                <div
                  v-else
                  class="d-flex flex-row justify-content-start align-items-center text-center"
                  style="
                  background-color: rgb(239 239 239);
                "
                >
                  <button
                    style="
                    background-color: transparent;
                    border: 0;
                    height: 20px;
                    min-width: 40px;
                  "
                    @click="incrementClick()"
                  >
                    <h4 style="font-size: 20px; line-height: 20px">+</h4>
                  </button>
                  <div>
                    <h4
                      style="
                      background-color: transparent;
                      margin: 10px;
                      height: 20px;
                      min-width: 30px;
                      line-height: 20px;
                    "
                      id="counter-label"
                    >{{ counterVal }}</h4>
                  </div>
                  <button
                    style="
                    background-color: transparent;
                    border: 0;
                    height: 20px;
                    min-width: 40px;
                  "
                    @click="decrementClick()"
                  >
                    <h4 style="font-size: 20px; line-height: 20px">-</h4>
                  </button>
                </div>
              </div>
              <div v-for="(item, index) in DBitems.options.options" :key="index">
                <div
                  v-if="item.type == 'select'"
                  class="orderInfo d-flex flex-row justify-content-between"
                  style="margin-bottom: 15px"
                >
                  <h5>{{ item.name }} :</h5>
                  <select
                    class="select"
                    :title="$t('SelectOne')"
                    @change="upadateprice($event, item.id)"
                  >
                    <option hidden selected>{{ $t("SelectOne") }}</option>
                    <option
                      :value="item1.id"
                      v-for="(item1, index) in item.option_values.select_values"
                      :key="index"
                    >{{ item1.name }}</option>
                  </select>
                </div>
                <div v-if="item.type == 'checkbox'">
                  <div v-for="(item1, index1) in checked" :key="index1">
                    <div
                      class="orderInfo d-flex flex-row justify-content-between"
                      style="margin-bottom: 15px"
                      v-if="checked[index1].id == item.id"
                    >
                      <h5>{{ item.name }} :</h5>
                      <div class="d-flex flex-row justify-content-between" style="width: 120px">
                        <label
                          v-if="$i18n.locale == 'ar'"
                          for="checkbox"
                        >{{ item.price }} {{ $store.state.unitAR }}</label>
                        <label v-else for="checkbox">{{ item.price }} {{ $store.state.unit }}</label>
                        <input
                          type="checkbox"
                          id="checkbox"
                          v-model="checked[index1].value"
                          style="width: 30px; height: 25px"
                          @change="changeCheckbox(item, checked[index1].value)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="quanity != 0" class="orderInfo mt-4">
                <h5>{{ $t("note") }}</h5>
                <textarea
                  rows="3"
                  cols="5"
                  class="form-control"
                  required
                  placeholder
                  v-model="note"
                ></textarea>
              </div>
              <button
                id="#addToCart"
                v-if="quanity != 0"
                class="orderInfo button mt-4"
                @click="addToCart"
              >{{ $t("Addtocart") }}</button>
              <div class="mt-4"><h5>{{  $t('Details') }}</h5>
            </div>
            <div
              v-if="DBitems.product.brand_logo != null"
              class="d-flex flex-row justify-content-start align-items-center mt-4"
              style="margin-bottom: 30px"
            >
              <div class="barndImg">
                <img :src="DBitems.product.brand_logo" />
              </div>
              <h5>{{ $t("brand") }}</h5>
              <h5>: {{ DBitems.product.brand_name }}</h5>
            </div>
            <div
              class="information d-flex flex-row justify-content-between w-50"
              v-for="(info, index) in this.DBitems.product_informations
                .product_informations"
              :key="index"
            >
              <h5>{{ info.option }} :</h5>
              <h5>{{ info.value }}</h5>
            </div>
           
            <div class="container" v-html="DBitems.product.description"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      v-if="validateMessage != ''"
      style="
        position: fixed;
        z-index: 100;
        width: 300px;
        bottom: 50px;
        left: 50px;
        border-radius: 5px;
        background-color: #fff;
        border: 2px solid var(--primary-color);
        text-align: center;
        padding-top: 5px;
      "
    >
      <p>{{ validateMessage }}</p>
    </div>
    <!-- ======= Second Section ======= -->
    <section id="Second" v-if="!loading">
      <div class="container" v-if="this.DBitems.similar_products.products.length != 0">
        <div class="section-title">
          <h2>{{ $t("similarProducts") }}</h2>
        </div>
        <div class="row">
          <div
            class="collg6 col-lg-3 col-md-4 col-sm-6 col-6 mb-5"
            v-for="(item, index) in this.DBitems.similar_products.products"
            :key="index"
          >
            <card3
              :name="item.name"
              :description="item.description"
              :is_favorit="item.is_favorit"
              :image="item.image"
              :old_price="item.old_price"
              :new_price="item.new_price"
              :productid="item.id"
            ></card3>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- End Second -->
</template>

<script>
import card3 from "./CardStyle3.vue";
import AddEvaluation from "./AddEvaluation.vue";
import Login from "../views/Login.vue";

import Lingallery from "lingallery";
import img from "../../../public/store/assets/image/slider/portfolio-8.jpg";

import Vodal from "vodal";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";

export default {
  components: { Vodal,  card3: () => import('./CardStyle3.vue') , Lingallery, AddEvaluation, Login },
  props: { id: Number, name: String },
  data: function() {
    return {
      counterVal: 1,
      loginVodal: false,
      loginMassage: "",

      currentId: null,
      width: 600,
      height: 350,

      DBitems: null,
      loading: false,

      options: [],
      selectedOptionArray: [],
      price: 0,
      quanity: 0,
      Firstquanity: 0,
      finalOptions: 0,
      checked: [],
      validateMessage: "",
      selectOption: false,

      fav: false,
      offer_price: 0,
      //is_offer: false,
      //discount: null,

      note: "",

      addeval: false
    };
  },
  created() {
    this.loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url +
          this.$store.storeName +
          "/product/" +
          this.id,
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        this.checked = [];
        this.DBitems = response.data.data;
        this.fav = this.DBitems.product.is_favorit;
        var option1 = this.DBitems.options.options;
        for (var i = 0; i < option1.length; i++) {
          //if option  not empty
          if (option1[i].option_values.select_values != null) {
            // if select
            var element = {};
            element.value_id = option1[i].option_values.select_values[0].id;
            element.option_id = option1[i].id;
            this.options.push(element);
            ///console.log(this.options.length +"iam theeeeeeeeeeeeeeer")
          } else {
            // if checkbox
            var checked = {};
            checked.id = option1[i].id;
            checked.value = false;
            this.checked.push(checked);
            //console.log(this.checked)
          }
        }
        //console.log(this.options)
      })
      .then(() => {
        this.loading = false;
        if (this.options.length != 0) {
          this.selectOption = true;
          /*// if we found select options
          var options = this.options;
          this.axios
            .post(
              this.$store.state.base_api_url +
                this.$store.storeName +
                "/product_price/" +
                this.$route.params.id,
              {
                options,
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              this.price = response.data.data.price;
              this.offer_price = response.data.data.new_price;
              this.quanity = response.data.data.quanity;
              this.Firstquanity = response.data.data.quanity;
              this.finalOptions = response.data.data.final_option;

              /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
              /////////////counteer////////////

              var checked_true = [];
              for (var i = 0; i < this.checked.length; i++) {
                if (this.checked[i].value == true) {
                  checked_true.push(this.checked[i].id);
                }
              }
              let S_name_full =
                this.$store.storeName +
                "/" +
                this.$route.params.id +
                this.finalOptions +
                checked_true;

              let S_name2 =
                this.$store.storeName +
                "/" +
                this.$route.params.id +
                this.finalOptions;
              console.log("S_name " + S_name2);

              let qun = this.quanity;

              let AllCookies = this.$cookies.keys();
              for (let i = 0; i < AllCookies.length; i++) {
                if (AllCookies[i].includes(S_name2)) {
                  // if (AllCookies[i] == S_name_full) {
                  //  console.log("hii i am there ");
                  //} else {
                  qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                  console.log(
                    this.$cookies.get(AllCookies[i]).quantity +
                      " quuuuun " +
                      qun
                  );
                  // }
                }
              }
              this.quanity = qun;
            });*/
        } else if (this.options.length == 0) {
          // if we not found select options
          //console.log("hiiiiiiiiii created" + this.DBitems.product.quanity);
          this.price = this.DBitems.product.sale_price;
          this.offer_price = this.DBitems.product.offer_price;
          this.quanity = this.DBitems.product.quantity;
          this.Firstquanity = this.DBitems.product.quantity;

          /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
          var checked_true = [];
          for (var i = 0; i < this.checked.length; i++) {
            if (this.checked[i].value == true) {
              checked_true.push(this.checked[i].id);
            }
          }
          let S_name_full =
            this.$store.storeName +
            "/" +
            this.id +
            this.finalOptions +
            checked_true;

          let S_name2 =
            this.$store.storeName + "/" + this.id + this.finalOptions;
          console.log("S_name " + S_name2);

          let qun = this.quanity;

          let AllCookies = this.$cookies.keys();
          for (let i = 0; i < AllCookies.length; i++) {
            if (AllCookies[i].includes(S_name2)) {
              // if (AllCookies[i] == S_name_full) {
              //  console.log("hii i am there ");
              //} else {
              qun = qun - this.$cookies.get(AllCookies[i]).quantity;
              console.log(
                this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
              );
              // }
            }
          }
          this.quanity = qun;
        }
      });
  },
  methods: {
    incrementClick() {
      /*var checked_true = [];
      for (var i = 0; i < this.checked.length; i++) {
        if (this.checked[i].value == true) {
          checked_true.push(this.checked[i].id);
        }
      }
      let S_name_full =
        this.$store.storeName +
        "/" +
        this.$route.params.id +
        this.finalOptions +
        checked_true;

      let S_name =
        this.$store.storeName + "/" + this.$route.params.id + this.finalOptions;
      console.log("S_name " + S_name);

      let qun = this.quanity;

      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].includes(S_name)) {
          if (AllCookies[i] == S_name_full) {
            console.log("hii i am there ");
          } else {
            qun = qun - this.$cookies.get(AllCookies[i]).quantity;
            console.log(
              this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
            );
          }
        }
      }*/

      if (this.quanity > 0) {
        if (this.counterVal < this.quanity) {
          ++this.counterVal;
          this.price = this.price / (this.counterVal - 1) + this.price;
          if (this.DBitems.product.is_offer) {
            this.offer_price =
              this.offer_price / (this.counterVal - 1) + this.offer_price;
            /*   this.offer_price =
              this.price - (this.DBitems.product.discount / 100) * this.price;*/
          }
        }
      } else {
        ++this.counterVal;
        this.price = this.price / (this.counterVal - 1) + this.price;
        if (this.DBitems.product.is_offer) {
          this.offer_price =
            this.offer_price / (this.counterVal - 1) + this.offer_price;
          /* this.offer_price =
            this.price - (this.DBitems.product.discount / 100) * this.price;*/
        }
      }
      //}
    },
    decrementClick() {
      if (this.counterVal > 1) {
        --this.counterVal;
        //this.price = this.price/2
        this.price = this.price - this.price / (this.counterVal + 1);
        if (this.DBitems.product.is_offer) {
          this.offer_price =
            this.offer_price - this.offer_price / (this.counterVal + 1);
          /*    this.offer_price =
            this.price - (this.DBitems.product.discount / 100) * this.price;*/
        }
      }
    },
    updatedata() {
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/product/" +
            this.id,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          this.DBitems = response.data.data;
          this.fav = this.DBitems.product.is_favorit;
        })
        .then(() => (this.loading = false));

      //this.$refs.childref.update(this.categoryID)
      this.$store.state.langchange = false;
    },
    upadateprice(event, option_id) {
      //console.log(this.options.length + "hlooooooo")
      //var unique_names = [...new Set(this.options)]
      //console.log(unique_names+"unique_names unique_names")

      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].option_id == option_id) {
          this.options[i].value_id = event.target.value;
          if (this.selectedOptionArray.length < this.options.length) {
            //if (!this.selectedOptionArray.includes(this.options[i].option_id)) {
            this.selectedOptionArray.push(this.options[i].option_id);
            //}
          }
        }
      }
      //console.log(this.options.length  +" hii " +this.selectedOptionArray.length)
      if (this.options.length == this.selectedOptionArray.length) {
        this.selectOption = false;

        // console.log(this.options)
        //option1.get(event)
        /*var options= [
            {
              option_id: 1,
              value_id: 2,
            },
            {
              option_id: 1,
              value_id: 2,
            },
          ];*/
        var options = this.options;
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/product_price/" +
              this.id,
            {
              options
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            this.price = response.data.data.price;
            this.offer_price = response.data.data.new_price;
            this.quanity = response.data.data.quanity;
            this.Firstquanity = response.data.data.quanity;
            this.finalOptions = response.data.data.final_option;
            for (var i = 0; i < this.checked.length; i++) {
              this.checked[i].value = false;
            }

            /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
            this.counterVal = 1;
            this.note = "";
            var checked_true = [];
            for (var i = 0; i < this.checked.length; i++) {
              if (this.checked[i].value == true) {
                checked_true.push(this.checked[i].id);
              }
            }
            let S_name_full =
              this.$store.storeName +
              "/" +
              this.id +
              this.finalOptions +
              checked_true;

            let S_name2 =
              this.$store.storeName + "/" + this.id + this.finalOptions;
            console.log("S_name " + S_name2);

            let qun = this.quanity;

            let AllCookies = this.$cookies.keys();
            for (let i = 0; i < AllCookies.length; i++) {
              if (AllCookies[i].includes(S_name2)) {
                // if (AllCookies[i] == S_name_full) {
                //  console.log("hii i am there ");
                //} else {
                qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                console.log(
                  this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
                );
                // }
              }
            }
            this.quanity = qun;
          });
      }
    },
    updateall() {
      this.loading = true;
      this.selectOption = false;
      this.counterVal = 1;
      this.options = [];
      this.selectedOptionArray = [];
      this.price = 0;
      this.offer_price = 0;
      this.quanity = 0;
      this.Firstquanity = 0;
      this.finalOptions = 0;
      this.checked = [];
      //this.validateMessage = "";

      this.axios
        .get(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/product/" +
            this.id,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          this.checked = [];
          this.DBitems = response.data.data;
          this.fav = this.DBitems.product.is_favorit;
          var option1 = this.DBitems.options.options;
          for (var i = 0; i < option1.length; i++) {
            //if option  not empty
            if (option1[i].option_values.select_values != null) {
              // if select
              var element = {};
              element.value_id = option1[i].option_values.select_values[0].id;
              element.option_id = option1[i].id;
              this.options.push(element);
            } else {
              // if checkbox
              var checked = {};
              checked.id = option1[i].id;
              checked.value = false;
              this.checked.push(checked);
              //console.log(this.checked)
            }
          }
          //console.log(this.options)
        })
        .then(() => {
          this.loading = false;
          if (this.options.length != 0) {
            this.selectOption = true;
            /*   // if we found select options
            var options = this.options;
            this.axios
              .post(
                this.$store.state.base_api_url +
                  this.$store.storeName +
                  "/product_price/" +
                  this.$route.params.id,
                {
                  options,
                },
                {
                  headers: {
                    "Accept-Language": this.$i18n.locale,
                  },
                }
              )
              .then((response) => {
                this.price = response.data.data.price;
                this.offer_price = response.data.data.new_price;
                this.quanity = response.data.data.quanity;
                this.Firstquanity = response.data.data.quanity;
                this.finalOptions = response.data.data.final_option;

                /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
                var checked_true = [];
                for (var i = 0; i < this.checked.length; i++) {
                  if (this.checked[i].value == true) {
                    checked_true.push(this.checked[i].id);
                  }
                }
                let S_name_full =
                  this.$store.storeName +
                  "/" +
                  this.$route.params.id +
                  this.finalOptions +
                  checked_true;

                let S_name2 =
                  this.$store.storeName +
                  "/" +
                  this.$route.params.id +
                  this.finalOptions;
                console.log("S_name " + S_name2);

                let qun = this.quanity;

                let AllCookies = this.$cookies.keys();
                for (let i = 0; i < AllCookies.length; i++) {
                  if (AllCookies[i].includes(S_name2)) {
                    // if (AllCookies[i] == S_name_full) {
                    //  console.log("hii i am there ");
                    //} else {
                    qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                    console.log(
                      this.$cookies.get(AllCookies[i]).quantity +
                        " quuuuun " +
                        qun
                    );
                    // }
                  }
                }
                this.quanity = qun;
              });*/
          } else if (this.options.length == 0) {
            // if we not found select options
            console.log(
              "hiiiiiiiiii updateall" + this.DBitems.product.sale_price
            );
            this.price = this.DBitems.product.sale_price;
            this.offer_price = this.DBitems.product.offer_price;
            this.quanity = this.DBitems.product.quantity;
            this.Firstquanity = this.DBitems.product.quantity;

            /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
            var checked_true = [];
            for (var i = 0; i < this.checked.length; i++) {
              if (this.checked[i].value == true) {
                checked_true.push(this.checked[i].id);
              }
            }
            let S_name_full =
              this.$store.storeName +
              "/" +
              this.id +
              this.finalOptions +
              checked_true;

            let S_name2 =
              this.$store.storeName + "/" + this.id + this.finalOptions;
            console.log("S_name " + S_name2);

            let qun = this.quanity;

            let AllCookies = this.$cookies.keys();
            for (let i = 0; i < AllCookies.length; i++) {
              if (AllCookies[i].includes(S_name2)) {
                // if (AllCookies[i] == S_name_full) {
                //  console.log("hii i am there ");
                //} else {
                qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                console.log(
                  this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
                );
                // }
              }
            }
            this.quanity = qun;
          }
        });
    },
    addToCart() {
      document.getElementById("#addToCart").style.display = "none";
      var checked_true = [];
      for (var i = 0; i < this.checked.length; i++) {
        if (this.checked[i].value == true) {
          checked_true.push(this.checked[i].id);
        }
      }
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/check_cart_item",
          {
            product_id: this.id,
            total_price: this.price,
            offer_price: this.offer_price,
            quantity: this.counterVal,
            final_option: this.finalOptions,
            option_check: checked_true
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          let product = null;
          if (response.data.code == "1") {
            // let products = new Map;
            let S_name1 =
              this.$store.storeName +
              "/" +
              this.id +
              this.finalOptions +
              checked_true;
            if (this.$cookies.isKey(S_name1)) {
              /*console.log(
                "this.price " +
                  this.price +
                  "this.$cookies.get( S_name1 ).total_price" +
                  this.$cookies.get(S_name1).total_price
              );*/
              product = {
                product_id: this.id,
                total_price:
                  this.price + this.$cookies.get(S_name1).total_price,
                offer_price:
                  this.offer_price + this.$cookies.get(S_name1).offer_price,
                quantity: this.counterVal + this.$cookies.get(S_name1).quantity,
                quantityAll: this.$cookies.get(S_name1).quantityAll,
                final_option: this.finalOptions,
                option_check: checked_true,
                discount: this.DBitems.product.discount,
                note: this.note + " " + this.$cookies.get(S_name1).note
              };
            } else {
              console.log("hlooooooooooo ::::::::; " + this.Firstquanity);
              product = {
                product_id: this.id,
                total_price: this.price,
                offer_price: this.offer_price,
                quantity: this.counterVal,
                quantityAll: this.Firstquanity,
                final_option: this.finalOptions,
                option_check: checked_true,
                discount: this.DBitems.product.discount,
                note: this.note
              };
            }
            //check if item is exist on cart or not
            //if (this.$cookies.isKey(this.$store.storeName+this.$route.params.id)) {
            // this.$cookies.remove('storeName')
            // products = this.$cookies.get(this.$store.storeName);
            //}
            //products.set(this.$route.params.id , product);
            let S_name = this.$store.storeName + "/";

            if (
              !this.$cookies.isKey(
                S_name +
                  product.product_id +
                  product.final_option +
                  product.option_check
              )
            ) {
              this.$store.state.cartCounter = this.$store.state.cartCounter + 1;
            }

            this.$cookies.set(
              S_name +
                product.product_id +
                product.final_option +
                product.option_check,
              product
            );
            console.log(this.$cookies.keys());
          }
          this.validateMessage = response.data.message;
          /*this.$router.push({
            name: "shoppingCart",
            params: {
              storeName: this.$store.storeName,
            },
          });*/
          this.updateall();
          document.getElementById("#addToCart").style.display = "block";
          setTimeout(() => {
            // this.updateall();
            this.validateMessage = "";
          }, 3000);
        });
    },
    addEvalu() {
      if (
        this.$localStorage.get(this.$store.storeName) != null &&
        this.DBitems.product.is_rate == true
      ) {
        this.addeval = true;
      } else if (
        this.$localStorage.get(this.$store.storeName) != null &&
        this.DBitems.product.is_rate == false
      ) {
        if (this.$i18n.locale == "en") {
          document
            .getElementsByClassName("hovertext")[0]
            .setAttribute(
              "data-hover",
              "You must purchase the product to add a review"
            );
        } else {
          document
            .getElementsByClassName("hovertext")[0]
            .setAttribute("data-hover", "يجب أن تشتري المنتج لإضافة تقييم");
        }
      } else {
        if (this.$i18n.locale == "en") {
          document
            .getElementsByClassName("hovertext")[0]
            .setAttribute("data-hover", "login to add evaluation");
        } else {
          document
            .getElementsByClassName("hovertext")[0]
            .setAttribute("data-hover", "سجل دخول لإضافة تقييم");
        }
      }
    },
    changeFav() {
      if (this.$localStorage.get(this.$store.storeName) != null) {
        this.axios
          .get(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/favourite_product_change/" +
              this.id,
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName)
              }
            }
          )
          .then(response => {
            if (response.data.code == "1") {
              this.fav = !this.fav;
            }
          });
      } else {
        if (this.$i18n.locale == "en") {
          this.loginMassage = "please Login";
          setTimeout(() => {
            this.loginMassage = "";
          }, 3000);
        } else {
          this.loginMassage = "يجب تسجيل الدخول";
          setTimeout(() => {
            this.loginMassage = "";
          }, 3000);
        }
      }
    },
    changeCheckbox(item, val) {
      if (val) {
        this.price = this.price + item.price * this.counterVal;
        if (this.offer_price != 0) {
          this.offer_price = this.offer_price + item.price * this.counterVal;
        }
      } else {
        /*(this.offer_price =
            this.price - (this.DBitems.product.discount / 100) * this.price))*/
        this.price = this.price - item.price * this.counterVal;
        if (this.offer_price != 0) {
          this.offer_price = this.offer_price - item.price * this.counterVal;
        }
        /*(this.offer_price =
            this.price - (this.DBitems.product.discount / 100) * this.price));*/
      }
    },
    productRoute() {
      if (this.$route.path.includes("/" + this.$store.storeName + "/product/" + this.id)) {
        }
      else if (this.$route.path.includes("/" + this.$store.storeName + "/product")) {
        this.$router.push({
          name: "product",
          params: { id: this.id, name: this.name,lang: this.$i18n.locale }
        });
      } else {
        this.$router.push({
          name: "product",
          params: {
            storeName: this.$store.storeName,
            id: this.id,
            name: this.name,
            lang: this.$i18n.locale
          }
        });
      }
    }
  },
  watch: {
    "$route.params": {
      handler(newValue) {
        this.updateall();
      },
      immediate: true
    }
  }
};
</script>
<style scoped>
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/

#Hero {
  margin-top: 20px;
}

#Second {
  padding-top: 0px;
}

.section-title h2 {
  font-size: 18px;
  font-family: "Araboto-Medium";
  color: #000;
  cursor: pointer;
}
.section-title h2:hover {
  color: var(--primary-color);
}

.fav-img,
.fav-full-img {
  width: 30px;
  height: 30px;
}

.pagination .page-item a {
  color: rgb(184 189 205);
  background-color: rgba(22, 22, 26, 0);
  border: none;
  text-decoration: underline;
  line-height: 0;
  border-radius: 100%;
  padding: 12px 10px 15px 10px;
}

.pagination .page-item a:hover {
  background-color: var(--primary-color);
  color: #fff;
  text-decoration: none;
}

.myBtn {
  color: #000000;
  font-size: 15px;
  margin: 0 5px;
  font-family: "Araboto-Bold";
}

.bi-star-fill {
  color: #ffcc00;
  font-size: 20px;
}

.button {
  cursor: pointer;
  background-color: var(--primary-color);
  border-radius: 10px;
  width: 100%;
  padding: 10px 65px 15px 65px;
  border: 2px solid var(--primary-color);
  color: #fff;
  font-size: 16px;
  font-family: "Araboto-Medium";
  text-align: center;
}

.button:hover {
  background-color: #fff;
  color: #000;
}

h5 {
  font-size: 16px;
  font-family: "Araboto-Medium";
  color: var(--secondary-color);
}

span {
  font-size: 14px;
  font-family: "Araboto-Light";
  color: var(--secondary-color);
}

select {
  border: 0;
  background-color: #efefef;
  /*box-shadow: 0px 0px 8px rgba(127, 137, 161, 0.25);
  border-radius: 10px;*/
  font-size: 16px;
  text-align: center;
  /*font-family: "Araboto-Medium";*/
  color: var(--secondary-color);
  padding: 8px 15px 10px 15px;
}

textarea {
  border: 1px solid var(--secondary-color);
  background-color: #fff;
  box-shadow: 0px 0px 8px rgba(127, 137, 161, 0.25);
  border-radius: 10px;
}

.star {
  color: rgb(180, 180, 180);
  margin-left: 2px;
  margin-right: 2px;
}
.star-fill {
  color: #ffcc00;
  margin-left: 2px;
  margin-right: 2px;
}

label {
  font-size: 16px;
  font-family: "Araboto-Medium";
  color: var(--secondary-color);
}

.hovertext {
  position: relative;

  color: #ffcc00;
  font-size: 25px;
  line-height: 25px;
}

.hovertext:before {
  content: attr(data-hover);
  visibility: hidden;
  opacity: 0;
  width: 140px;
  margin-top: 10px;
  background-color: rgb(239, 239, 239);
  color: rgb(0, 0, 0);
  text-align: center;
  border-radius: 5px;
  padding: 5px 0;
  transition: opacity 1s ease-in-out;
  font-size: 10px;

  position: absolute;
  z-index: 1;
  left: 0;
  top: 110%;
}

.hovertext:hover:before {
  opacity: 1;
  visibility: visible;
}

.barndImg {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: inline-block;
  box-shadow: 0 0 10px #8d8d8d;
  margin-left: 20px;
  margin-right: 20px;
}
.barndImg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 100%;
}

/*@media (min-width: 2000px) {
  .collg6 {
    width: 15%;
  }
}*/
@media (max-width: 1200px) {
  .card {
    width: 100%;
  }
}
@media (max-width: 992px) {
  .section-title {
    text-align: center;
  }
  h2 {
    font-size: 30px;
  }
  h5 {
    font-size: 18px;
    margin-bottom: 10px !important;
  }
  span {
    font-size: 16px;
  }

  label,
  select {
    font-size: 15px;
  }
  .myBtn {
    font-size: 12px;
  }
  .bi-star-fill {
    font-size: 18px;
  }
  .information,
  .orderInfo {
    width: 70% !important;
    margin-right: 15%;
    margin-left: 15%;
  }
}
@media (max-width: 575px) {
  .card {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
  h2 {
    font-size: 12px;
  }
  h5 {
    font-size: 15px;
    margin-bottom: 10px !important;
  }
  span {
    font-size: 12px;
  }
  .fav-img {
    width: 30px;
    height: 30px;
  }
  
  .star {
    width: 60%;
    margin-right: 20%;
    margin-left: 20%;
    margin-bottom: 10px;
  }
  .star {
    justify-content: space-between !important;
    width: 100% !important;
    margin: 5px 0 10px 0 !important;
  }
  .star button {
    width: 30px !important;
    height: 30px !important;
    margin: 0px !important;
  }
  .star .hovertext {
    line-height: 20px;
  }
  .barndImg {
    width: 25px;
    height: 25px;
  }
}
@media (max-width: 390px) {
  .star {
    width: 80%;
    margin-right: 10%;
    margin-left: 10%;
  }
  .information,
  .orderInfo {
    width: 90% !important;
    margin-right: 5%;
    margin-left: 5%;
  }
}
</style>
